import type {CapaRecord,CapaStatus} from "./domain/models";
export const stages: Array<{ id: CapaStatus; label: string }> = [
  { id: "UNDER_REVIEW", label: "Değerlendirme" },
  { id: "ACTION_IN_PROGRESS", label: "Faaliyet" },
  { id: "EFFECTIVENESS_REVIEW", label: "Etkinlik kontrolü" },
  { id: "CLOSED", label: "Kapatıldı" },
];

export function date(value: string | null) {
  return value
    ? new Intl.DateTimeFormat("tr-TR", { dateStyle: "medium" }).format(
        new Date(value),
      )
    : "—";
}

export function visibleCapaRecords(records:CapaRecord[],search:string,stage:CapaStatus|null) {return records.filter(record=>{const haystack=(record.capaNo+" "+record.title+" "+record.description+" "+record.createdByName).toLocaleLowerCase("tr");return (!stage||record.status===stage)&&haystack.includes(search.toLocaleLowerCase("tr"));});}
